import { withStyles, Container } from "@material-ui/core";
import React, { useEffect } from "react";
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import styles from "./styles";
import * as generalActions from "../../actions/general";
import SharedItem from "../../components/SharedItem";
// import InfiniteScroll from "react-infinite-scroll-component";
import Breadcrumbs from "../../components/Breadcrumbs";
import Seo from "../../components/Seo";

function SharedList(props) {
  const { item, generalActionList, classes, sharedLists } = props;
  const { fetchSharedList } = generalActionList;
  useEffect(() => {
    fetchSharedList();
  }, [fetchSharedList])

  const mapParams = () => {
    let params = [{ name: "Chia sẻ", cate: "shared", to: "/chia-se" }];

    if (item) {
      params.push({
        name: item.name,
        cate: "news-child",
        to: item.alias
      });
    }

    return params;
  };

  const seoData = {
    seo_title: "Chia sẻ kinh nghiệm lập trình website và mobile app",
    seo_description: "Bằng những kinh nghiệm làm các dự án lớn nhỏ, chúng tôi sẵn sàng chia sẻ mọi kinh nghiệm trong qua trình làm việc, với nhiều bài viết chính xác và dễ hiểu nhất",
    name: "Công ty TNHH thiết kế và lập trình website, app mobile Wasth"
  }

  
  const renderShared = () => {
    if(sharedLists && sharedLists.length > 0){
      return sharedLists.map(item => <SharedItem key={item.id} item={item} seoData={seoData}/>);
    }
  }

  return (
    <div>
      <Seo seoContent={item && item.seo_title !== null ? item : seoData}/>
      <Breadcrumbs params={mapParams()} />
      <Container maxWidth="xl"> 
        <div className={classes.container}>
          {renderShared()}
        </div> 
      </Container>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    sharedLists:  state.general.sharedList,
  }
};

const mapDisPatchToProps = dispatch => {
  return {
    generalActionList: bindActionCreators(generalActions, dispatch)
  }
};

const withConnect = connect(mapStateToProps, mapDisPatchToProps);

export default compose(withStyles(styles), withConnect)(SharedList);